import Hook from "../../utils/hook"

export const ContentsPage = Hook(`ContentsPage`, {
  refs: [`map`],
  targets: [`mobileMapToggle`],
  values: { mobileMapActive: Boolean },
  actions: [
    {
      name: `showMobileMap`,
      target: `mobileMapToggle`,
      type: `click`,
    },
  ],

  enterMapFullscreenOnLoad: false,

  mapRefMounted(mapRef) {
    mapRef.addReceiveHandler(this.mapReceive.bind(this))
  },

  showMobileMapAction() {
    this.mobileMapActiveValue = true

    if (this.mapRef && this.mapRef.el.dataset.naturkartanInited)
      this.enterMapFullscreen()
    else this.enterMapFullscreenOnLoad = true
  },

  mapReceive(message) {
    switch (message.method) {
      case `loaded`: {
        if (this.enterMapFullscreenOnLoad) {
          this.enterMapFullscreenOnLoad = false
          this.enterMapFullscreen()
        }
        break
      }

      case `setFullscreen`: {
        this.mobileMapActiveValue = message.active
        break
      }
    }
  },

  enterMapFullscreen() {
    if (this.mapRef) this.mapRef.setFullscreen(true)
  },
})
